﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            notSetPictureUrl: String
        };
    }

    static get targets() {
        return ["shouldRemovePicture", "previewPicture", "removePicture", "pictureFile", "presetPicture"];
    }

    dispatchChangedEvent({ detail: { xhr: { status } } }) {
        if (status === 200) {
            this.dispatch("changed", { bubbles: true });
        }
    }

    removePicture(e) {
        e.preventDefault();
        this.shouldRemovePictureTarget.value = true;
        this.previewPictureTarget.style.backgroundImage = `url("${this.notSetPictureUrlValue}")`;
        this.removePictureTarget.classList.add("invisible");
        this.pictureFileTarget.value = null;
        this.presetPictureTargets.forEach(ppt => {
            ppt.checked = false;
        });
    }

    selectPictureFile() {
        const [file] = this.pictureFileTarget.files;
        this.shouldRemovePictureTarget.value = !file;
        this.removePictureTarget.classList.toggle("invisible", !file);
        this.previewPictureTarget.style.backgroundImage = `url("${file ? URL.createObjectURL(file) : this.notSetPictureUrlValue}")`;
        this.presetPictureTargets.forEach(ppt => {
            ppt.checked = false;
        });
    }

    selectPresetPicture({ target }) {
        this.shouldRemovePictureTarget.value = false;
        this.removePictureTarget.classList.remove("invisible");
        this.previewPictureTarget.style.backgroundImage = `url("${target.parentNode.querySelector("img").src}")`;
        this.pictureFileTarget.value = null;
    }
}
